// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2OElf","logo":"Header_logo__2rkav"};